import { ApplyButtonTexts } from '@doda/common/src/types/jobSearchDetail';

/**
 * DODASITE-25064 応募ボタンUI変更ABテスト 応募ボタンのテキスト定義
 * ABテストで使用する3種類の文言セット
 * キーは計測仕様に合わせて文字列 '1' | '2' | '3' を使用
 * - '1': オリジナル版
 * - '2': テストパターンA版
 * - '3': テストパターンB版
 */
export const APPLY_BUTTON_TEXT_VARIANTS: Record<
  '1' | '2' | '3',
  ApplyButtonTexts
> = {
  '1': {
    directApply: '応募する',
    agentApply: '応募依頼する',
    balloonText: null,
  },
  '2': {
    directApply: '会員登録して応募する',
    agentApply: '会員登録して応募依頼する',
    balloonText: '3分で、かんたん登録！',
  },
  '3': {
    directApply: '会員登録して応募する',
    agentApply: '会員登録して応募依頼する',
    balloonText: '登録・利用はすべて無料！',
  },
};
